var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("sfe.route.extendedwarrantyresults") } },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "FPermission",
                  rawName: "v-FPermission",
                  value: { pageName: _vm.pageName, list: ["LIST"] },
                  expression: "{ pageName, list: ['LIST'] }",
                },
              ],
              staticClass: "action-container",
            },
            [
              _c(
                "el-form",
                {
                  staticClass: "searchForm",
                  attrs: {
                    model: _vm.searchVal,
                    size: "small",
                    inline: "",
                    "label-position": "top",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.orderNumber"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.orderNumber },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchVal,
                              "orderNumber",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.barCode"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.barCode },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "barCode", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.qrcode"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.qrcode },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "qrcode", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.status"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            clearable: "",
                            placeholder: _vm.$t("common.pleaseSelect"),
                          },
                          model: {
                            value: _vm.searchVal.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchVal, "status", $$v)
                            },
                            expression: "searchVal.status",
                          },
                        },
                        _vm._l(_vm.statusList, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.name, value: item.code },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.ruleCodeList"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            multiple: "",
                            clearable: "",
                            placeholder: _vm.$t("common.pleaseSelect"),
                          },
                          model: {
                            value: _vm.searchVal.ruleCodeList,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchVal, "ruleCodeList", $$v)
                            },
                            expression: "searchVal.ruleCodeList",
                          },
                        },
                        _vm._l(
                          _vm.lookupList["TIRE_L_RULE"],
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.code },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.retailerId"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.retailerId },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "retailerId", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.retailerName"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.retailerName },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchVal,
                              "retailerName",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "flexRow",
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.createTime"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "startDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.createStartTime,
                              valueformat: "yyyy-MM-dd",
                              "picker-options": _vm.startPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "createStartTime",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "picker-line" }, [_vm._v("-")]),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { prop: "endDay" } },
                        [
                          _c("FormDatePicker", {
                            attrs: {
                              val: _vm.searchVal.createEndTime,
                              valueformat: "yyyy-MM-dd",
                              "picker-options": _vm.endPickerOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchVal,
                                  "createEndTime",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.tireOrderRatingList"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { clearable: "", multiple: "" },
                          model: {
                            value: _vm.searchVal.tireOrderRatingList,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.searchVal,
                                "tireOrderRatingList",
                                $$v
                              )
                            },
                            expression: "searchVal.tireOrderRatingList",
                          },
                        },
                        [
                          _c("el-option", {
                            key: "1",
                            attrs: { label: "1", value: "1" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: "2",
                            attrs: { label: "2", value: "2" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: "3",
                            attrs: { label: "3", value: "3" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: "4",
                            attrs: { label: "4", value: "4" },
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            key: "5",
                            attrs: { label: "5", value: "5" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("sfe.extendedwarrantyresults.input.sku"),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.sku },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(_vm.searchVal, "sku", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "sfe.extendedwarrantyresults.input.sapDescription"
                        ),
                      },
                    },
                    [
                      _c("FormInput", {
                        attrs: { val: _vm.searchVal.sapDescription },
                        on: {
                          "update:val": function ($event) {
                            return _vm.$set(
                              _vm.searchVal,
                              "sapDescription",
                              $event
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer-right" }, slot: "footer-right" },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  attrs: { size: "small", icon: "el-icon-refresh" },
                  on: { click: _vm.resetData },
                },
                [_vm._v(_vm._s(_vm.$t("common.reset")) + "\n        ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "FPermission",
                      rawName: "v-FPermission",
                      value: { pageName: _vm.pageName, list: ["LIST"] },
                      expression: "{ pageName, list: ['LIST'] }",
                    },
                  ],
                  staticClass: "t-search-btn",
                  attrs: { size: "small", icon: "el-icon-search" },
                  on: { click: _vm.searchData },
                },
                [_vm._v(_vm._s(_vm.$t("common.search")) + "\n        ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("common.list") },
        },
        [
          _c("div", { attrs: { slot: "header-right" }, slot: "header-right" }, [
            _c(
              "div",
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "FPermission",
                        rawName: "v-FPermission",
                        value: { pageName: _vm.pageName, list: ["EXPORT"] },
                        expression: "{ pageName, list: ['EXPORT'] }",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.downloadExcel },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$t("common.export")) +
                        "\n          "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "orderNumber",
                  label: _vm.$t("sfe.extendedwarrantyresults.orderNumber"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "barCode",
                  label: _vm.$t("sfe.extendedwarrantyresults.barCode"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "qrcode",
                  label: _vm.$t("sfe.extendedwarrantyresults.qrcode"),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: _vm.$t("sfe.extendedwarrantyresults.status"),
                  "min-width": "100",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireOrderRating",
                  label: _vm.$t("sfe.extendedwarrantyresults.tireOrderRating"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "rulesValueListStr",
                  label: _vm.$t(
                    "sfe.extendedwarrantyresults.rulesValueListStr"
                  ),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: _vm.$t("sfe.extendedwarrantyresults.remark"),
                  "min-width": "200",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "lyTireSpecMatchingResult",
                  label: _vm.$t(
                    "sfe.extendedwarrantyresults.lyTireSpecMatchingResult"
                  ),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "warrantyExtensionReview",
                  label: _vm.$t(
                    "sfe.extendedwarrantyresults.warrantyExtensionReview"
                  ),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList[
                                  "WARRANTY_EXTENSION_REVIEW_MAPPING"
                                ] &&
                                  _vm.lookupList[
                                    "WARRANTY_EXTENSION_REVIEW_MAPPING"
                                  ][scope.row.warrantyExtensionReview]) ||
                                  scope.row.warrantyExtensionReview
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerId",
                  label: _vm.$t("sfe.extendedwarrantyresults.retailerId"),
                  "min-width": "120",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerName",
                  label: _vm.$t("sfe.extendedwarrantyresults.retailerName"),
                  "min-width": "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "retailerAddress",
                  label: _vm.$t("sfe.extendedwarrantyresults.retailerAddress"),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireItemNo",
                  label: _vm.$t("sfe.extendedwarrantyresults.tireItemNo"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sku",
                  label: _vm.$t("sfe.extendedwarrantyresults.sku"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tirePosition",
                  label: _vm.$t("sfe.extendedwarrantyresults.tirePosition"),
                  "min-width": "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [
                          _vm._v(
                            " " +
                              _vm._s(
                                (_vm.lookupList["TIRE_POSITION_MAPPING"] &&
                                  _vm.lookupList["TIRE_POSITION_MAPPING"][
                                    scope.row.tirePosition
                                  ]) ||
                                  scope.row.tirePosition
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sapDescription",
                  label: _vm.$t("sfe.extendedwarrantyresults.sapDescription"),
                  "min-width": "300",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "licensePlate",
                  label: _vm.$t("sfe.extendedwarrantyresults.licensePlate"),
                  "min-width": "150",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brandModule",
                  label: _vm.$t("sfe.extendedwarrantyresults.brandModule"),
                  "min-width": "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "tireOrderCreateTime",
                  label: _vm.$t(
                    "sfe.extendedwarrantyresults.tireOrderCreateTime"
                  ),
                  "min-width": "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }